module.exports = __webpack_public_path__ + "static/media/Belize - BZ.819545ad.png";